export default "__VITE_ASSET__Di12Whxf__"